const state = {
  visible: false,
  message: null,
  type: null
};

const actions = {
  handleError: ({ commit }, error) => {
    let errorMessage = "Unable to process request.";
    const messageReturned = !!(error.response && error.response.data);
    if (
      messageReturned &&
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      Object.keys(error.response.data.errors).length
    ) {
      const respObj = error.response.data.errors;
      const errorMessageArr = [];
      Object.values(respObj).forEach((value) => errorMessageArr.push(value));
      errorMessage = errorMessageArr.toString();
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.detail
    ) {
      let detailObj = error.response.data.detail;
      let errorMessageArr = [];
      Object.values(detailObj).forEach((value) => errorMessageArr.push(value));

      const finalErrMsg = errorMessageArr.toString();
      if (finalErrMsg.includes("Customer phone # is blocked by do not text list")) { // CTM Do Not Text List
        errorMessage = `Unable to send SMS. Customer's phone # is on Do Not Text List.
                        <br />Send QuickPay link via email instead.`;
      } else {
        errorMessage = finalErrMsg;
      }
    } else if (messageReturned && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (messageReturned && error.response.data.error) {
      if (error.response.data.error.message) {
        errorMessage = error.response.data.error.message;
      }
      if (error.response.data.error.detail) {
        errorMessage = error.response.data.error.detail;
      }
    } else if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === "string") {
      errorMessage = error;
    }
    commit("setMessage", { message: errorMessage, type: "error" });
    return errorMessage;
  },

  handleSuccess: ({ commit }, message) => {
    commit("setMessage", { message: message, type: "success" });
  },

  handleAlert: ({ commit }, message) => {
    commit("setMessage", { message: message, type: "alert" });
  }
};

const mutations = {
  setMessage: (state, payload) => {
    state.message = payload.message;
    state.type = payload.type;
    state.visible = true;
  },

  setVisible: (state, setting) => {
    state.visible = setting;
  }
};

export default {
  state,
  actions,
  mutations
};
